(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('subtaskSelect', {
        templateUrl: 'views/components/views/subtaskSelect/subtaskSelect.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'subtaskSelectService', function ($stateParams, stateService, subtaskSelectService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let argValue = $stateParams.argvalue;
            let custactNoAddTo = $stateParams.custact_no_addto;
            let isChecked = true;

            vm.model = {
                bgCategoryDataSelection: {
                    selected: 'S',
                    buttons: [
                        { id: 'S', label: 'categorydataselect_select', color: 'primary', onClick: () => vm.model.bgCategoryDataSelection.selected = 'S' },
                        { id: 'C', label: 'categorydataselect_components', color: 'primary', onClick: () => vm.model.bgCategoryDataSelection.selected = 'C' },
                        { id: 'G', label: 'categorydataselect_goto', color: 'primary', onClick: () => vm.model.bgCategoryDataSelection.selected = 'G' }
                    ]
                },
                itemsListSubTasks: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALL
            
            async function loadSubTasks() {
                vm.model.itemsListSubTasks = await subtaskSelectService.listSubTasks({
                    custact_no: argValue,
                    retrievetype: 'child',
                    include_top: '0',
                    functiontype: vm.model.bgCategoryDataSelection.selected
                });
            }

            // #endregion LOAD PROCEDURE CALL

            // #region VALIDATION FUNCTION
            
            vm.validateCheckItem = function (item) {
                if (item.item_is_selected == '1') {
                    item.item_is_selected = '0';
                    item.item_glyphicon_color = 'black';
                    item.item_glyphicon = 'glyphicon-unchecked';
                } else {
                    item.item_is_selected = '1';
                    item.item_glyphicon_color = 'green';
                    item.item_glyphicon = 'glyphicon-check';
                }
            }

            // #endregion VALIDATION FUNCTION

            // #region CHANGE ALL SELECTION FUNCTION

            vm.changeAllSelections = function () {
                if (isChecked === false) {
                    vm.model.itemsListSubTasks.forEach((item) => {
                        item.item_is_selected = '1';
                        item.item_glyphicon_color = 'green';
                        item.item_glyphicon = 'glyphicon-check';
                    });

                    isChecked = true;
                } else {
                    vm.model.itemsListSubTasks.forEach((item) => {
                        item.item_is_selected = '0';
                        item.item_glyphicon_color = 'black';
                        item.item_glyphicon = 'glyphicon-unchecked';
                    });

                    isChecked = false;
                }
            }

            // #endregion CHANGE ALL SELECTION FUNCTION

            // #region CHECK FUNCTION
            
            vm.addSelected = function () {
                subtaskSelectService.addItems({
                    custact_no_from: argValue,
                    custact_no_addto: custactNoAddTo,
                    records: vm.model.itemsListSubTasks.map(function (a) {
                        return {
                            "item_id": a.item_id,
                            "item_name": a.item_name,
                            "item_is_selected": a.item_is_selected
                        };
                    })
                }).then(() => {
                    stateService.back(2);
                });
            }

            // #endregion CHECK FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgCategoryDataSelection = function (value) {
                vm.model.bgCategoryDataSelection.selected = value;

                loadSubTasks();
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSubTasks();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
